module.exports = {
  "/forms/:portalId": {},
  "/forms/:portalId/manage": {},
  "/forms/:portalId/views/:viewName": {
    "success": {
      "forms dashboard table": [
        "FORMS_DASHBOARD_TABLE_LOAD"
      ],
      "forms dashboard no results": [
        "FORMS_DASHBOARD_NO_RESULTS"
      ],
      "forms zero state": [
        "FORMS_DASHBOARD_ZERO_STATE"
      ],
      "forms no business units state": [
        "FORMS_DASHBOARD_NO_BUSINESS_UNITS"
      ]
    },
    "error": [
      "FORMS_DASHBOARD_VIEWS_ERROR"
    ]
  },
  "/forms/:portalId/folders": {
    "success": {
      "forms dashboard table": [
        "FORMS_DASHBOARD_TABLE_LOAD"
      ],
      "forms dashboard no results": [
        "FORMS_DASHBOARD_NO_RESULTS"
      ],
      "forms zero state": [
        "FORMS_DASHBOARD_ZERO_STATE"
      ],
      "forms no business units state": [
        "FORMS_DASHBOARD_NO_BUSINESS_UNITS"
      ]
    },
    "error": [
      "FORMS_DASHBOARD_FOLDERS_ERROR"
    ]
  },
  "/forms/:portalId/analyze": {
    "success": {
      "portal form submissions data well": [
        "PORTAL_FORM_SUBMISSIONS_DATA_WELL_LOADED"
      ],
      "portal form submissions chart": [
        "PORTAL_FORM_SUBMISSIONS_CHART_LOADED"
      ],
      "portal form submissions table": [
        "PORTAL_FORM_SUBMISSIONS_TABLE_LOADED"
      ]
    },
    "error": [
      "PANEL_ERROR",
      "PORTAL_FORM_SUBMISSIONS_DATA_WELL_LOAD_ERROR",
      "PORTAL_FORM_SUBMISSIONS_CHART_LOAD_ERROR",
      "PORTAL_FORM_SUBMISSIONS_TABLE_LOAD_ERROR"
    ]
  },
  "/forms/:portalId/templates": {
    "success": {
      "forms template": [
        "FORMS_TEMPLATE_LOADED"
      ]
    }
  },
  "/forms/:portalId/type": {
    "success": {
      "forms type": [
        "FORMS_TYPE_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit": {},
  "/forms/:portalId/editor/:formGuid/edit/form": {
    "success": {
      "form editor panels": [
        "FORM_EDITOR_PANELS_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit/options": {
    "success": {
      "options panel": [
        "OPTIONS_PANEL_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit/test": {
    "success": {
      "preview panel": [
        "PREVIEW_PANEL_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit/automation": {
    "success": {
      "automation tab": [
        "AUTOMATION_TAB_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit/form/field/:propertyId/:fieldId": {
    "success": {
      "form field editor panel": [
        "FORM_FIELD_EDITOR_PANEL_LOADED"
      ]
    }
  },
  "/forms/:portalId/editor/:formGuid/edit/form/field/:fieldId": {
    "success": {
      "form field editor panel": [
        "FORM_FIELD_EDITOR_PANEL_LOADED"
      ]
    }
  },
  "/forms/:portalId/compare": {
    "success": {
      "comparison tool loaded": [
        "COMPARISON_TOOL_LOADED"
      ],
      "forms dashboard table": [
        "FORMS_DASHBOARD_TABLE_LOAD"
      ],
      "forms dashboard no results": [
        "FORMS_DASHBOARD_NO_RESULTS"
      ],
      "forms no business units state": [
        "FORMS_DASHBOARD_NO_BUSINESS_UNITS"
      ],
      "forms zero state": [
        "FORMS_ZERO_STATE"
      ]
    },
    "error": [
      "PANEL_ERROR"
    ]
  },
  "/forms/:portalId/:formGuid": {},
  "/forms/:portalId/:formGuid/edit/form": {},
  "/forms/:portalId/editor/:formGuid": {},
  "/forms/:portalId/:formGuid/edit": {},
  "/forms/:portalId/editor/:formGuid/:corruptedPath": {},
  "/forms/:portalId/editor/:formGuid/edit/form/:corruptedPath": {}
};